module.exports = __webpack_public_path__ + "static/media/data.8b5080be.png";